import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	inject,
	Input,
	OnChanges,
	Output,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { clean } from "@intocare/util";

import { LocationResult } from "./../../entities/geolocation";

@Component({
	selector: "ic-address-form",
	templateUrl: "./address-form.component.html",
	styleUrls: ["./address-form.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AddressFormComponent implements OnChanges {
	private fb = inject(UntypedFormBuilder);
	private cdRef = inject(ChangeDetectorRef);

	@Input() address: LocationResult;

	@Output() saveItem = new EventEmitter<LocationResult>();
	@Output() cancelItem = new EventEmitter();

	locationForm: UntypedFormGroup;

	constructor() {
		this.locationForm = this.fb.group({
			street: ["", Validators.required],
			number: ["", Validators.required],
			zip: ["", Validators.required],
			box: [""],
			city: ["", Validators.required],
			state: [""],
			country: [{ value: "", disabled: true }, Validators.required],
			countryCode: [{ value: "", disabled: true }, Validators.required],
		});
	}

	invalid() {
		this.cdRef.detectChanges();
	}

	save() {
		this.saveItem.emit(this.locationForm.getRawValue());
	}

	cancel() {
		this.locationForm.reset();
		this.cancelItem.emit();
	}

	ngOnChanges() {
		if (this.address) {
			this.locationForm.patchValue(clean(this.address));
		}
	}
}
